"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=painel.js.map